module.exports = __webpack_public_path__ + "98795747.svg";